import * as React from "react";
import * as Metadata from '../../entities/Metadata';
import { DisplayFieldService } from "./DisplayFieldService";
import { Dictionary, EntityType } from "../../entities/common";

type Props = {
    field: Metadata.Field;
    entity: Dictionary<any>;
    entityType?: EntityType;
    viewType?: "List" | 'Card' | 'Timeline' | 'Tooltip';
    disableNavigation?: boolean;
    withPopupView?: boolean;
}

export const DisplayField: React.FunctionComponent<Props> = props => {
    const field = props.field;
    if (!field) {
        return null;
    }

    const fieldValue = props.entity.attributes[field.name];
    const Formatter = React.useMemo(() => {
        return DisplayFieldService.getFieldFormatter(field, !props.disableNavigation, props.entityType, props.viewType, props.withPopupView)
    }, [props.field, props.entity, props.entityType, props.viewType, props.disableNavigation, props.withPopupView]);

    if (Formatter) {
        return <Formatter item={props.entity} value={fieldValue} />;
    }

    return <>{fieldValue !== undefined && fieldValue !== null ? `${fieldValue}` : ''}</>;
}